
export function get_config(){
    return {
//	wp_api_host: 'https://michiel-1.legekopie.ramplaankwartier.zonnewarmte.nl',
//	wp_api_host: 'https://techteam.kopie.ramplaankwartier.zonnewarmte.nl',
	//
	wp_api_host: 'http://localhost:8080',
	wp_api_path: '/wp-json/cft-digidome/v1'
    }
}


